import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { PERMISSIONS } from '../../constants';
import list from './ListWhatsappNumber';
import create from './CreateWhatsappNumber';
import edit from './EditWhatsappNumber';

export default {
  list,
  create,
  edit,
  name: 'chains/chainId/whatsapp-numbers',
  options: { label: 'Números de WhatsApp' },
  icon: WhatsAppIcon,
  permissions: [PERMISSIONS.MANAGE_WHATSAPP_NUMBERS],
};
